var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCelo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "#282C31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4736 16.5789C17.7118 16.5789 19.5262 14.7645 19.5262 12.5263C19.5262 10.2881 17.7118 8.47368 15.4736 8.47368C13.2353 8.47368 11.4209 10.2881 11.4209 12.5263C11.4209 14.7645 13.2353 16.5789 15.4736 16.5789ZM15.4736 18.0526C12.4216 18.0526 9.94727 15.5783 9.94727 12.5263C9.94727 9.47432 12.4216 7 15.4736 7C18.5256 7 20.9999 9.47432 20.9999 12.5263C20.9999 15.5783 18.5256 18.0526 15.4736 18.0526Z",
    fill: "#35D07F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5263 19.5262C14.7645 19.5262 16.5789 17.7118 16.5789 15.4736C16.5789 13.2353 14.7645 11.4209 12.5263 11.4209C10.2881 11.4209 8.47368 13.2353 8.47368 15.4736C8.47368 17.7118 10.2881 19.5262 12.5263 19.5262ZM12.5263 20.9999C9.47432 20.9999 7 18.5256 7 15.4736C7 12.4216 9.47432 9.94727 12.5263 9.94727C15.5783 9.94727 18.0526 12.4216 18.0526 15.4736C18.0526 18.5256 15.5783 20.9999 12.5263 20.9999Z",
    fill: "#FBCC5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.655 18.0505C16.038 17.5865 16.3125 17.0427 16.4584 16.459C17.0421 16.313 17.5859 16.0386 18.05 15.6557C18.0288 16.3315 17.8833 16.9977 17.6206 17.6208C16.9974 17.8836 16.3311 18.0293 15.6551 18.0505H15.655ZM11.5418 11.5425C10.9581 11.6884 10.4143 11.9628 9.9502 12.3458C9.97136 11.6699 10.1169 11.0037 10.3796 10.3806C11.0028 10.1179 11.6691 9.9723 12.3451 9.95117C11.9622 10.4152 11.6877 10.9588 11.5418 11.5425Z",
    fill: "#ECFF8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelo);
export default __webpack_public_path__ + "static/media/celo.9eaa4a9625ab8e045844dc59f6fe34ec.svg";
export { ForwardRef as ReactComponent };